import './App.css';
import Main from "./components/Main";

function App() {
  return (
    <div id="app">
      <Main />
    </div>
  );
}

export default App;
